<template>

  <div class="lotti-report-module">

    <div class="lotti-module-title">PDF Ausdruck</div>

    <el-form :model="pdfFormData" label-width="0px" ref="pdfFormData" class="lotti-module-form">

      <el-checkbox-group
          class="lotti-report-calculated-block"
          v-model="pdfFormData.calculated"
          :change="handleCheckboxChange()"
          size="mini">
        <el-checkbox-button :label="'calc'">Berech.</el-checkbox-button>
        <el-checkbox-button :label="'non_calc'">Nicht Berech.</el-checkbox-button>
        <el-checkbox-button :label="'holidays'">Ferien</el-checkbox-button>
      </el-checkbox-group>

      <el-form-item class="lotti-select-form">

        <el-select
            class="lotti-report-float-block"
            v-model="pdfFormData.categoryValue"
            size="medium"
            multiple
            filterable
            :multiple-limit="10"
            clearable
            :change="onChangeCategory()"
            reserve-keyword
            placeholder="Kategorie wählen">
          <el-option-group
              v-for="group in categoryOptions"
              :key="group.label"
              :label="group.label">
            <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>

        <el-select
            v-if="leadView"
            :class="getSmallSelectClass()"
            v-model="pdfFormData.therapistId"
            size="medium"
            filterable>
          <el-option
              v-for="item in therapistOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <el-select
            :class="getSmallSelectClass()"
            v-model="pdfFormData.statusValue"
            size="medium"
            multiple
            filterable
            clearable
            reserve-keyword
            :change="onChangeStatus()"
            placeholder="Status wählen">
          <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <el-select
            v-if="communityOptions.length > 2"
            v-model="pdfFormData.communityServiceId"
            size="medium"
            filterable>
          <el-option
              v-for="item in communityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item>

        <div class="lotti-report-date-block">

          <el-date-picker
              v-model="pdfFormData.dateFrom"
              size="small"
              type="date"
              format="dd.MM.yyyy"
              placeholder="Start"
              :picker-options="datePickerHelper.getOptions()">
          </el-date-picker>

          <el-date-picker
              v-model="pdfFormData.dateTo"
              size="small"
              type="date"
              format="dd.MM.yyyy"
              placeholder="Ende"
              :picker-options="datePickerHelper.getOptions()">
          </el-date-picker>

        </div>

        <el-button type="primary" @click="submitReportForm">Erstellen</el-button>
      </el-form-item>

    </el-form>

  </div>

</template>

<script>
import auth from '../../auth.js';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';
import downloadHelper from '../../Helpers/DownloadHelper.js';
import sessionHelper from "../../Helpers/SessionHelper";
import notification from "../../Helpers/NotificationHelper";
import Vue from "../../main";

export default {

  props: {
    leadView: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      calculatedOld: ['calc'],//helper array

      pdfFormData: {
        calculated: ['calc'],
        dateFrom: '',
        dateTo: '',
        statusValue: ['all'],
        categoryValue: ['all'],
        therapistId: null,//always id of therapist is set
        communityServiceId: 0,//default for all communities
      },

      statusOptions: sessionHelper.getStatusTypesListPlusAllSelector(),
      categoryOptions: sessionHelper.getAllCategoryTypesPlusAllSelector(),
      therapistOptions: [],
      communityOptions: [],
    }
  },

  methods: {

    onChangeStatus() {
      this.handleMultiSelectAllOption(this.pdfFormData.statusValue);
      //additionally, reset to 'all' if all status options are selected :)
      if (this.pdfFormData.statusValue.length === 6) {
        this.pdfFormData.statusValue = ['all'];
      }
    },

    onChangeCategory() {
      this.handleMultiSelectAllOption(this.pdfFormData.categoryValue);
    },

    handleMultiSelectAllOption(arr) {
      if (arr.length > 1 && arr.filter(e => e === 'all').length > 0) {
        if (arr[0] === 'all') {
          //remove 'all'
          arr.shift();
        } else {
          //reset to 'all' = remove all other options
          arr.splice(0, arr.length - 1);
        }
      } else if (arr.length === 0) {
        //append 'all' to empty array
        arr[0] = 'all';
      }
    },

    getSmallSelectClass() {
      return this.leadView ? 'lotti-small-select' : '';
    },

    handleCheckboxChange() {
      //if no checkbox is checked, then check the other one
      if (this.pdfFormData.calculated.length === 0) {
        this.pdfFormData.calculated.push(this.calculatedOld === 'calc' ? 'non_calc' : 'calc')
      }
      this.calculatedOld = this.pdfFormData.calculated[0] === 'calc' ? 'calc' : 'non_calc';
    },

    submitReportForm() {

      downloadHelper.reportPdf(
          this.pdfFormData.calculated,
          this.pdfFormData.statusValue,
          this.pdfFormData.categoryValue,
          this.pdfFormData.therapistId,
          this.pdfFormData.communityServiceId,
          this.pdfFormData.dateFrom ? datePickerHelper.formatUTCDateUS(this.pdfFormData.dateFrom) : null,
          this.pdfFormData.dateTo ? datePickerHelper.formatUTCDateUS(this.pdfFormData.dateTo) : null,
          () => {
            notification.showSuccess(this, 'PDF wurde erfolgreich erstellt');
          },
          () => {
            notification.showError(this, 'Fehler beim Erstellen des PDF');
          }
      )
    },

    getAllTherapists() {
      Vue.http.get(
          'api/v1/therapist/get-all'
      ).then(response => {
        this.therapistOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    GetAllLinkedCommunitiesOfMyService() {
      Vue.http.get(
          'api/v1/service/get-all-linked-communities'
      ).then(response => {
        this.communityOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
        this.communityOptions.unshift({ value: 0, label: 'Alle Gemeinden' })
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

  },

  beforeMount() {

    //get all therapists of service if user is lead_therapist, else only user itself
    this.getAllTherapists();

    //get all communities ("Gemeinden") linked to my service
    this.GetAllLinkedCommunitiesOfMyService();
  },

  mounted() {
    //if user is set, set own id as therapistId
    if (this.auth.user.profile.id) {
      this.pdfFormData.therapistId = this.auth.user.profile.id
    }
  }
}

</script>